export default __webpack_public_path__ + "static/media/evier.98194500.pdf";